import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ToasterService } from 'src/app/services/toaster.service';

@Component({
  selector: 'app-toaster',
  templateUrl: './toaster.component.html',
  styleUrls: ['./toaster.component.scss'],
  imports: [AsyncPipe],
})
export class ToasterComponent {
  protected toasterService = inject(ToasterService);

  get durationMs(): number {
    return this.toasterService.durationMs;
  }

  get displayMessage(): string {
    const { titleToast, textToast } = this.toasterService;

    if (titleToast && textToast) {
      return `${titleToast} ${textToast}`;
    }

    return titleToast || textToast;
  }

  getIconPath(type: string): string {
    switch (type) {
      case 'error':
        return '../../../assets/icons/icon-error-outlined.svg';
      case 'success':
        return '../../../assets/icons/icon-check-outlined.svg';
      case 'warning':
        return '../../../assets/icons/icon-warning-outlined.svg';
      default:
        return '';
    }
  }

  getIconAlt(type: string): string {
    switch (type) {
      case 'error':
        return 'Ícone de erro';
      case 'success':
        return 'Ícone de sucesso';
      case 'warning':
        return 'Ícone de alerta';
      default:
        return '';
    }
  }
}
